import admin from './admin'
import assessments from './assessments'
import auth from './auth'
import charts from './charts'
import dashboard from './dashboard'
import participants from './participants'
import userConfigurations from './userConfigurations'
import users from './users'
import userStudies from './userStudies'

const api = {
  admin,
  assessments,
  auth,
  charts,
  dashboard,
  participants,
  userStudies,
  userConfigurations,
  users,
}

export default api
